import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ClassificationCard } from './types';

interface ClassificationLevelDeleteModalProps {
  card: ClassificationCard | null;
  isPersisting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ClassificationLevelDeleteModal: React.FC<
  ClassificationLevelDeleteModalProps
> = ({ card, isPersisting, onClose, onConfirm }) => {
  const displayName =
    card?.classificationLevel?.name ||
    card?.classification.name ||
    'this classification';

  return (
    <Transition show={card !== null} as={React.Fragment}>
      <Dialog as="div" className="relative z-[60]" onClose={onClose}>
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
            >
              <Dialog.Panel className="flex w-full max-w-md flex-col rounded-xl bg-white shadow-xl transition-all">
                <div className="border-b border-gray-200 px-4 py-3">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium text-gray-900"
                  >
                    Delete classification level
                  </Dialog.Title>
                </div>
                <div className="px-4 py-4">
                  <p className="text-sm text-gray-700">
                    Are you sure you want to delete{' '}
                    <span className="font-medium">{displayName}</span>?
                  </p>
                </div>
                <div className="flex justify-end gap-2 border-t border-gray-200 px-4 py-3">
                  <button
                    type="button"
                    disabled={isPersisting}
                    onClick={onClose}
                    className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    disabled={isPersisting}
                    onClick={onConfirm}
                    className="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    {isPersisting ? 'Deleting...' : 'Delete'}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ClassificationLevelDeleteModal;
